<template>
  <f7-page name="send-command">

    <f7-progressbar v-if="isLoading" color="green" infinite class="progressbar-top" key="1"></f7-progressbar>
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('Commands') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="inputSubmitId" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>

    <form @submit.prevent="onSubmit">
      <input type="submit" :id="inputSubmitId" hidden >
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            :label="$t('IMEI')"
            :placeholder="$t('IMEI')"
            class="disabled"
            :value="f7route.query.imei"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-number text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            :label="$t('IMSI')"
            :placeholder="$t('IMSI')"
            :value="f7route.query.imsi"
            class="disabled"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-other-imei text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            :label="$t('DeviceType')"
            :placeholder="$t('DeviceType')"
            :value="f7route.query.deviceType"
            class="disabled"
        >
          <template #media>
            <f7-icon icon="f7-icons  text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>

        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Command')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :after="$t('SelectOption')"
            required
            validate
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-commands text-color-lightgray"></f7-icon>
          </template>

          <select name="SimCommands" v-model="CommandCode">
            <option
                v-for="command in SimCommands"
                :key="command.Code"
                :value="command.Code"
            >{{command.Name}}</option>
          </select>
          
        </f7-list-item>
        <template v-if="CommandCode=='custom'" class="p-col-12 p-sm-12">
            <f7-list-input
                type="text"
                :label="'Message'"
                :placeholder="$t('Type a command')"
                v-model:value="custom"
            >
              <template #media>
                <f7-icon icon="f7-icons icon- text-color-lightgray"></f7-icon>
              </template>
            </f7-list-input>
            <!--<Textarea id="smscustom" v-model="custom" rows="5" cols="30" />
            <label for="smscustom"></label>-->
          </template>

      </f7-list>
    </form>

  </f7-page>
</template>

<script>
import {mapGetters} from "vuex";
import { SortArrayByObjProps } from "../../js/helpers";
import {f7} from "framework7-vue";
import {QTAPI} from "../../services/qt-api";

export default {
  name: "send-command",

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'SimCommands'])
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  data() {
    return {
      isLoading: false,
      inputSubmitId: f7.utils.id(),
      custom: '',
      CommandCode: null,
    }
  },

  mounted() {

  },

  methods: {
    async onSubmit(){

      this.isLoading = true;

      if(this.CommandCode == 'custom'){          
        let query = {
          IMSI: this.f7route.query.imsi,
          SMS: this.custom
        }
        if(!this.custom.length){ 
          f7.dialog.alert('Custom field is empty', 'GPS Secure Admin Alert')
          this.isLoading = false          
          return
        }
        let assetsToSend = query.SMS.split('\r\n').join('@@@separator@@@').split('\n').join('@@@separator@@@').split('<br>').join('@@@separator@@@').split('@@@separator@@@')

        assetsToSend.forEach(async subEl => {
          const result = await fetch('https://newapi.quiktrak.co/QuikData/v1/SMS/SendSMS?deviceId=' + query.IMSI + '&message=' + encodeURIComponent(subEl)).catch(e => {
            console.log(e)
            f7.dialog.alert('Command was not sent', 'GPS Secure Admin Alert')  
            return
          })     

          this.isLoading = false
          
          const jsonResult = await result.json()
          //if (jsonResult.MajorCode == '000') {                      
            f7.notification.create({
              subtitle: this.$t('Success'),
              text: this.$t('CommandSent'),
            }).open()
            this.f7router.back()
          /*} else {
            f7.dialog.alert('Command was not sent', 'Alert')        
            return
          }*/
        })        
      }else{

        let response = await QTAPI.SimSendCommand({
          IMSI: this.f7route.query.imsi,
          SMSType: this.CommandCode,
        })
        this.isLoading = false;
        if (!response){
          return
        }

        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('CommandSent'),
        }).open()
        this.f7router.back()
      }
      this.custom = '' 

    }
  }

}
</script>

<style scoped>

</style>